export interface Provincia {
  sigla: string;
  nome: string;
  regione: string;
}

export const PROVINCE: Provincia[] = [
  { sigla: 'AG', nome: 'Agrigento', regione: 'Sicilia' },
  { sigla: 'AL', nome: 'Alessandria', regione: 'Piemonte' },
  { sigla: 'AN', nome: 'Ancona', regione: 'Marche' },
  { sigla: 'AO', nome: 'Aosta', regione: "Valle d'Aosta" },
  { sigla: 'AP', nome: 'Ascoli Piceno', regione: 'Marche' },
  { sigla: 'AQ', nome: "L'Aquila", regione: 'Abruzzo' },
  { sigla: 'AR', nome: 'Arezzo', regione: 'Toscana' },
  { sigla: 'AT', nome: 'Asti', regione: 'Piemonte' },
  { sigla: 'AV', nome: 'Avellino', regione: 'Campania' },
  { sigla: 'BA', nome: 'Bari', regione: 'Puglia' },
  { sigla: 'BG', nome: 'Bergamo', regione: 'Lombardia' },
  { sigla: 'BI', nome: 'Biella', regione: 'Piemonte' },
  { sigla: 'BL', nome: 'Belluno', regione: 'Veneto' },
  { sigla: 'BN', nome: 'Benevento', regione: 'Campania' },
  { sigla: 'BO', nome: 'Bologna', regione: 'Emilia-Romagna' },
  { sigla: 'BR', nome: 'Brindisi', regione: 'Puglia' },
  { sigla: 'BS', nome: 'Brescia', regione: 'Lombardia' },
  { sigla: 'BT', nome: 'Barletta-Andria-Trani', regione: 'Puglia' },
  { sigla: 'BZ', nome: 'Bolzano', regione: 'Trentino-Alto Adige' },
  { sigla: 'CA', nome: 'Cagliari', regione: 'Sardegna' },
  { sigla: 'CB', nome: 'Campobasso', regione: 'Molise' },
  { sigla: 'CE', nome: 'Caserta', regione: 'Campania' },
  { sigla: 'CH', nome: 'Chieti', regione: 'Abruzzo' },
  { sigla: 'CI', nome: 'Carbonia-Iglesias', regione: 'Sardegna' },
  { sigla: 'CL', nome: 'Caltanissetta', regione: 'Sicilia' },
  { sigla: 'CN', nome: 'Cuneo', regione: 'Piemonte' },
  { sigla: 'CO', nome: 'Como', regione: 'Lombardia' },
  { sigla: 'CR', nome: 'Cremona', regione: 'Lombardia' },
  { sigla: 'CS', nome: 'Cosenza', regione: 'Calabria' },
  { sigla: 'CT', nome: 'Catania', regione: 'Sicilia' },
  { sigla: 'CZ', nome: 'Catanzaro', regione: 'Calabria' },
  { sigla: 'EN', nome: 'Enna', regione: 'Sicilia' },
  { sigla: 'FC', nome: 'Forlì-Cesena', regione: 'Emilia-Romagna' },
  { sigla: 'FE', nome: 'Ferrara', regione: 'Emilia-Romagna' },
  { sigla: 'FG', nome: 'Foggia', regione: 'Puglia' },
  { sigla: 'FI', nome: 'Firenze', regione: 'Toscana' },
  { sigla: 'FM', nome: 'Fermo', regione: 'Marche' },
  { sigla: 'FR', nome: 'Frosinone', regione: 'Lazio' },
  { sigla: 'GE', nome: 'Genova', regione: 'Liguria' },
  { sigla: 'GO', nome: 'Gorizia', regione: 'Friuli-Venezia Giulia' },
  { sigla: 'GR', nome: 'Grosseto', regione: 'Toscana' },
  { sigla: 'IM', nome: 'Imperia', regione: 'Liguria' },
  { sigla: 'IS', nome: 'Isernia', regione: 'Molise' },
  { sigla: 'KR', nome: 'Crotone', regione: 'Calabria' },
  { sigla: 'LC', nome: 'Lecco', regione: 'Lombardia' },
  { sigla: 'LE', nome: 'Lecce', regione: 'Puglia' },
  { sigla: 'LI', nome: 'Livorno', regione: 'Toscana' },
  { sigla: 'LO', nome: 'Lodi', regione: 'Lombardia' },
  { sigla: 'LT', nome: 'Latina', regione: 'Lazio' },
  { sigla: 'LU', nome: 'Lucca', regione: 'Toscana' },
  { sigla: 'MB', nome: 'Monza e della Brianza', regione: 'Lombardia' },
  { sigla: 'MC', nome: 'Macerata', regione: 'Marche' },
  { sigla: 'ME', nome: 'Messina', regione: 'Sicilia' },
  { sigla: 'MI', nome: 'Milano', regione: 'Lombardia' },
  { sigla: 'MN', nome: 'Mantova', regione: 'Lombardia' },
  { sigla: 'MO', nome: 'Modena', regione: 'Emilia-Romagna' },
  { sigla: 'MS', nome: 'Massa-Carrara', regione: 'Toscana' },
  { sigla: 'MT', nome: 'Matera', regione: 'Basilicata' },
  { sigla: 'NA', nome: 'Napoli', regione: 'Campania' },
  { sigla: 'NO', nome: 'Novara', regione: 'Piemonte' },
  { sigla: 'NU', nome: 'Nuoro', regione: 'Sardegna' },
  { sigla: 'OG', nome: 'Ogliastra', regione: 'Sardegna' },
  { sigla: 'OR', nome: 'Oristano', regione: 'Sardegna' },
  { sigla: 'OT', nome: 'Olbia-Tempio', regione: 'Sardegna' },
  { sigla: 'PA', nome: 'Palermo', regione: 'Sicilia' },
  { sigla: 'PC', nome: 'Piacenza', regione: 'Emilia-Romagna' },
  { sigla: 'PD', nome: 'Padova', regione: 'Veneto' },
  { sigla: 'PE', nome: 'Pescara', regione: 'Abruzzo' },
  { sigla: 'PG', nome: 'Perugia', regione: 'Umbria' },
  { sigla: 'PI', nome: 'Pisa', regione: 'Toscana' },
  { sigla: 'PL', nome: 'Pola', regione: 'Istria' },
  { sigla: 'PN', nome: 'Pordenone', regione: 'Friuli-Venezia Giulia' },
  { sigla: 'PO', nome: 'Prato', regione: 'Toscana' },
  { sigla: 'PR', nome: 'Parma', regione: 'Emilia-Romagna' },
  { sigla: 'PT', nome: 'Pistoia', regione: 'Toscana' },
  { sigla: 'PU', nome: 'Pesaro e Urbino', regione: 'Marche' },
  { sigla: 'PV', nome: 'Pavia', regione: 'Lombardia' },
  { sigla: 'PZ', nome: 'Potenza', regione: 'Basilicata' },
  { sigla: 'RA', nome: 'Ravenna', regione: 'Emilia-Romagna' },
  { sigla: 'RC', nome: 'Reggio Calabria', regione: 'Calabria' },
  { sigla: 'RE', nome: 'Reggio Emilia', regione: 'Emilia-Romagna' },
  { sigla: 'RG', nome: 'Ragusa', regione: 'Sicilia' },
  { sigla: 'RI', nome: 'Rieti', regione: 'Lazio' },
  { sigla: 'RM', nome: 'Roma', regione: 'Lazio' },
  { sigla: 'RN', nome: 'Rimini', regione: 'Emilia-Romagna' },
  { sigla: 'RO', nome: 'Rovigo', regione: 'Veneto' },
  { sigla: 'SA', nome: 'Salerno', regione: 'Campania' },
  { sigla: 'SI', nome: 'Siena', regione: 'Toscana' },
  { sigla: 'SO', nome: 'Sondrio', regione: 'Lombardia' },
  { sigla: 'SP', nome: 'La Spezia', regione: 'Liguria' },
  { sigla: 'SR', nome: 'Siracusa', regione: 'Sicilia' },
  { sigla: 'SS', nome: 'Sassari', regione: 'Sardegna' },
  { sigla: 'SU', nome: 'Sud Sardegna', regione: 'Sardegna' },
  { sigla: 'SV', nome: 'Savona', regione: 'Liguria' },
  { sigla: 'TA', nome: 'Taranto', regione: 'Puglia' },
  { sigla: 'TE', nome: 'Teramo', regione: 'Abruzzo' },
  { sigla: 'TN', nome: 'Trento', regione: 'Trentino-Alto Adige' },
  { sigla: 'TO', nome: 'Torino', regione: 'Piemonte' },
  { sigla: 'TP', nome: 'Trapani', regione: 'Sicilia' },
  { sigla: 'TR', nome: 'Terni', regione: 'Umbria' },
  { sigla: 'TS', nome: 'Trieste', regione: 'Friuli-Venezia Giulia' },
  { sigla: 'TV', nome: 'Treviso', regione: 'Veneto' },
  { sigla: 'UD', nome: 'Udine', regione: 'Friuli-Venezia Giulia' },
  { sigla: 'VA', nome: 'Varese', regione: 'Lombardia' },
  { sigla: 'VB', nome: 'Verbano-Cusio-Ossola', regione: 'Piemonte' },
  { sigla: 'VC', nome: 'Vercelli', regione: 'Piemonte' },
  { sigla: 'VE', nome: 'Venezia', regione: 'Veneto' },
  { sigla: 'VI', nome: 'Vicenza', regione: 'Veneto' },
  { sigla: 'VR', nome: 'Verona', regione: 'Veneto' },
  { sigla: 'VS', nome: 'Medio Campidano', regione: 'Sardegna' },
  { sigla: 'VT', nome: 'Viterbo', regione: 'Lazio' },
  { sigla: 'VV', nome: 'Vibo Valentia', regione: 'Calabria' },
];

export const trovaSigla = (input: string): string => {
  if (!input) return '';
  const normalizzato = input.trim().toLowerCase();
  // Se è già una sigla valida (2 lettere maiuscole)
  const siglaMaiuscola = input.trim().toUpperCase();
  if (PROVINCE.some(p => p.sigla === siglaMaiuscola)) return siglaMaiuscola;
  // Cerca per nome completo o parziale
  const esatta = PROVINCE.find(p => p.nome.toLowerCase() === normalizzato);
  if (esatta) return esatta.sigla;
  const parziale = PROVINCE.find(p => p.nome.toLowerCase().startsWith(normalizzato));
  if (parziale) return parziale.sigla;
  return input.trim().toUpperCase().slice(0, 2);
};
